// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal-module--overlay--1ksaj","close":"modal-module--close--3uc07","inner":"modal-module--inner--2iFbr"};